var map = {
	"./ad.svg": 14715,
	"./ae.svg": 70510,
	"./af.svg": 70405,
	"./ag.svg": 11712,
	"./ai.svg": 7122,
	"./al.svg": 35715,
	"./am.svg": 8438,
	"./ao.svg": 70600,
	"./aq.svg": 31802,
	"./ar.svg": 41985,
	"./arab.svg": 95220,
	"./as.svg": 28540,
	"./at.svg": 16395,
	"./au.svg": 30462,
	"./aw.svg": 23280,
	"./ax.svg": 68991,
	"./az.svg": 76489,
	"./ba.svg": 50943,
	"./bb.svg": 51140,
	"./bd.svg": 59750,
	"./be.svg": 20691,
	"./bf.svg": 82424,
	"./bg.svg": 19261,
	"./bh.svg": 2682,
	"./bi.svg": 16324,
	"./bj.svg": 23196,
	"./bl.svg": 32830,
	"./bm.svg": 20619,
	"./bn.svg": 18704,
	"./bo.svg": 8597,
	"./bq.svg": 32463,
	"./br.svg": 80391,
	"./bs.svg": 99929,
	"./bt.svg": 26614,
	"./bv.svg": 19400,
	"./bw.svg": 14605,
	"./by.svg": 50471,
	"./bz.svg": 16268,
	"./ca.svg": 68756,
	"./cc.svg": 21682,
	"./cd.svg": 50381,
	"./cefta.svg": 85111,
	"./cf.svg": 24867,
	"./cg.svg": 67574,
	"./ch.svg": 18129,
	"./ci.svg": 30252,
	"./ck.svg": 92778,
	"./cl.svg": 11141,
	"./cm.svg": 28192,
	"./cn.svg": 5179,
	"./co.svg": 25934,
	"./cp.svg": 29225,
	"./cr.svg": 6143,
	"./cu.svg": 22296,
	"./cv.svg": 75891,
	"./cw.svg": 33894,
	"./cx.svg": 46529,
	"./cy.svg": 36988,
	"./cz.svg": 23991,
	"./de.svg": 69325,
	"./dg.svg": 8931,
	"./dj.svg": 34826,
	"./dk.svg": 88839,
	"./dm.svg": 19781,
	"./do.svg": 47483,
	"./dz.svg": 41050,
	"./eac.svg": 11989,
	"./ec.svg": 65048,
	"./ee.svg": 16322,
	"./eg.svg": 33764,
	"./eh.svg": 19595,
	"./er.svg": 97229,
	"./es-ct.svg": 23504,
	"./es-ga.svg": 8501,
	"./es-pv.svg": 9311,
	"./es.svg": 18376,
	"./et.svg": 15087,
	"./eu.svg": 89074,
	"./fi.svg": 85875,
	"./fj.svg": 77336,
	"./fk.svg": 12413,
	"./fm.svg": 13247,
	"./fo.svg": 20745,
	"./fr.svg": 39616,
	"./ga.svg": 78272,
	"./gb-eng.svg": 29036,
	"./gb-nir.svg": 54359,
	"./gb-sct.svg": 67546,
	"./gb-wls.svg": 42536,
	"./gb.svg": 52379,
	"./gd.svg": 65329,
	"./ge.svg": 90380,
	"./gf.svg": 26983,
	"./gg.svg": 74730,
	"./gh.svg": 60813,
	"./gi.svg": 20776,
	"./gl.svg": 60377,
	"./gm.svg": 93236,
	"./gn.svg": 8143,
	"./gp.svg": 79349,
	"./gq.svg": 35811,
	"./gr.svg": 80235,
	"./gs.svg": 93137,
	"./gt.svg": 93185,
	"./gu.svg": 43516,
	"./gw.svg": 91418,
	"./gy.svg": 42872,
	"./hk.svg": 34691,
	"./hm.svg": 4729,
	"./hn.svg": 6098,
	"./hr.svg": 13086,
	"./ht.svg": 11164,
	"./hu.svg": 24609,
	"./ic.svg": 31604,
	"./id.svg": 50083,
	"./ie.svg": 82198,
	"./il.svg": 90747,
	"./im.svg": 12078,
	"./in.svg": 72389,
	"./io.svg": 16640,
	"./iq.svg": 43298,
	"./ir.svg": 94601,
	"./is.svg": 95812,
	"./it.svg": 81715,
	"./je.svg": 87803,
	"./jm.svg": 7491,
	"./jo.svg": 33005,
	"./jp.svg": 22842,
	"./ke.svg": 91216,
	"./kg.svg": 77822,
	"./kh.svg": 56105,
	"./ki.svg": 21316,
	"./km.svg": 49176,
	"./kn.svg": 2771,
	"./kp.svg": 45009,
	"./kr.svg": 34535,
	"./kw.svg": 52814,
	"./ky.svg": 95636,
	"./kz.svg": 14543,
	"./la.svg": 37633,
	"./lb.svg": 67930,
	"./lc.svg": 59191,
	"./li.svg": 48841,
	"./lk.svg": 16191,
	"./lr.svg": 61706,
	"./ls.svg": 15719,
	"./lt.svg": 54784,
	"./lu.svg": 46661,
	"./lv.svg": 73614,
	"./ly.svg": 81529,
	"./ma.svg": 91182,
	"./mc.svg": 9792,
	"./md.svg": 72903,
	"./me.svg": 74378,
	"./mf.svg": 83377,
	"./mg.svg": 95500,
	"./mh.svg": 6467,
	"./mk.svg": 2216,
	"./ml.svg": 52911,
	"./mm.svg": 86930,
	"./mn.svg": 88249,
	"./mo.svg": 50356,
	"./mp.svg": 39499,
	"./mq.svg": 32542,
	"./mr.svg": 98965,
	"./ms.svg": 45936,
	"./mt.svg": 89239,
	"./mu.svg": 5466,
	"./mv.svg": 11777,
	"./mw.svg": 2236,
	"./mx.svg": 57491,
	"./my.svg": 99142,
	"./mz.svg": 67453,
	"./na.svg": 25971,
	"./nc.svg": 92957,
	"./ne.svg": 93100,
	"./nf.svg": 40068,
	"./ng.svg": 44886,
	"./ni.svg": 62859,
	"./nl.svg": 74042,
	"./no.svg": 75809,
	"./np.svg": 26454,
	"./nr.svg": 3400,
	"./nu.svg": 90767,
	"./nz.svg": 60896,
	"./om.svg": 53612,
	"./pa.svg": 49357,
	"./pc.svg": 88963,
	"./pe.svg": 34681,
	"./pf.svg": 41202,
	"./pg.svg": 67215,
	"./ph.svg": 24288,
	"./pk.svg": 27515,
	"./pl.svg": 51020,
	"./pm.svg": 53873,
	"./pn.svg": 14858,
	"./pr.svg": 94502,
	"./ps.svg": 55443,
	"./pt.svg": 85892,
	"./pw.svg": 85695,
	"./py.svg": 43349,
	"./qa.svg": 65338,
	"./re.svg": 47491,
	"./ro.svg": 69797,
	"./rs.svg": 92009,
	"./ru.svg": 79123,
	"./rw.svg": 62461,
	"./sa.svg": 37476,
	"./sb.svg": 68127,
	"./sc.svg": 62581,
	"./sd.svg": 90365,
	"./se.svg": 22904,
	"./sg.svg": 30854,
	"./sh-ac.svg": 86142,
	"./sh-hl.svg": 62762,
	"./sh-ta.svg": 79231,
	"./sh.svg": 73217,
	"./si.svg": 23548,
	"./sj.svg": 11671,
	"./sk.svg": 71450,
	"./sl.svg": 59381,
	"./sm.svg": 38224,
	"./sn.svg": 60267,
	"./so.svg": 11902,
	"./sr.svg": 88175,
	"./ss.svg": 45362,
	"./st.svg": 40845,
	"./sv.svg": 91747,
	"./sx.svg": 45361,
	"./sy.svg": 86764,
	"./sz.svg": 7015,
	"./tc.svg": 31647,
	"./td.svg": 12088,
	"./tf.svg": 18278,
	"./tg.svg": 4275,
	"./th.svg": 91196,
	"./tj.svg": 10810,
	"./tk.svg": 79319,
	"./tl.svg": 2288,
	"./tm.svg": 80501,
	"./tn.svg": 93118,
	"./to.svg": 79051,
	"./tr.svg": 86130,
	"./tt.svg": 33256,
	"./tv.svg": 71094,
	"./tw.svg": 14723,
	"./tz.svg": 96106,
	"./ua.svg": 78582,
	"./ug.svg": 27988,
	"./um.svg": 9482,
	"./un.svg": 81,
	"./us.svg": 77624,
	"./uy.svg": 50270,
	"./uz.svg": 97749,
	"./va.svg": 67835,
	"./vc.svg": 90149,
	"./ve.svg": 70311,
	"./vg.svg": 80785,
	"./vi.svg": 3875,
	"./vn.svg": 25383,
	"./vu.svg": 86647,
	"./wf.svg": 30903,
	"./ws.svg": 32846,
	"./xk.svg": 82323,
	"./xx.svg": 81032,
	"./ye.svg": 95526,
	"./yt.svg": 8880,
	"./za.svg": 94295,
	"./zm.svg": 6003,
	"./zw.svg": 96677
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8128;